import { render, staticRenderFns } from "./AnnotationTrack.vue?vue&type=template&id=36684408&"
import script from "./AnnotationTrack.vue?vue&type=script&lang=js&"
export * from "./AnnotationTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports